<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <ProductForm v-model="product" title="Nový produkt" :loading="saving" @save="save" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import ProductForm from '../../../components/product/ProductForm'

export default {
  name: 'SupplierProductAdd',
  components: {
    ProductForm,
  },
  data() {
    return {
      product: {},
      saving: false,
    }
  },
  methods: {
    ...mapActions({
      createSupplierProduct: 'supplier/createSupplierProduct',
    }),
    save() {
      this.saving = true
      this.createSupplierProduct({
        supplierId: this.$route.params.supplierId,
        type: this.$route.params.type,
        product: this.product,
      })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
